import { Persona } from "src/app/entities/shared/Persona";

export class Row {
  persona: Persona;

  constructor(persona: Persona) {
    this.persona = persona;
  }
}
